module.exports = __webpack_public_path__ + "media/images/digivent/avatar-placeholder-f843fc76adbb97c86bf33f75b7ea65ea.png";